import { unionBy } from 'lodash';
import {
  APPEND_USERS,
  REFRESH_USERS,
  CLEAR_SESSION,
  NEW_SESSION,
  REMOVE_USER,
  MERGE_USER,
} from '../actions/user.actions';

const initialState = {
  session: null,
  users: [],
};

export default function users(state = initialState, { type, payload }) {
  switch (type) {
    case MERGE_USER:
      return { ...state, session: { ...state.session, ...payload } };
    case REMOVE_USER:
      return {
        ...state,
        users: state.users.filter(
          (user) => user._id !== payload && user.userId !== payload,
        ),
      };
    case APPEND_USERS:
      return {
        ...state,
        users: unionBy([...payload, ...state.users], 'userId'),
      };
    case REFRESH_USERS:
      return {
        ...state,
        users: payload,
      };
    case CLEAR_SESSION:
      return {
        ...state,
        ...initialState,
      };
    case NEW_SESSION:
      return {
        ...state,
        session: payload,
      };
    default:
      return state;
  }
}
